/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Tool_Posture_Changed_DescInputs */



/**
* | output |
* | --- |
* | "The organisation's default tool-enablement posture was changed." |
*
* @param {Audit_Details_Tool_Posture_Changed_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_tool_posture_changed_desc = /** @type {((inputs?: Audit_Details_Tool_Posture_Changed_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Tool_Posture_Changed_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Standardeinstellung der Organisation für die Werkzeugfreigabe wurde geändert.")
	return /** @type {LocalizedString} */ ("The organisation's default tool-enablement posture was changed.")
});